import {environment} from '../../../environments/environment';

export class Constant {

  public static readonly ROOT = environment.apiBaseUrl;
  public static readonly ROOT_API_V1 = environment.apiBaseUrl + '/api/v1';
  public static readonly NOT_FINISHED = 0;
  public static readonly FINISHED = 1;
  public static readonly USER = 1;
  public static readonly INVITED_USER = 2;
  public static readonly INVITED = 3;
  public static readonly RB_ADD_NEW = '1';
  public static readonly RB_SEARCH = '2';
  public static readonly BATCH = 1;
  public static readonly ONE2ONE = 0;
  public static readonly INACTIVE = 0;
  public static readonly ACTIVE = 1;
  public static readonly DELETED = 1;
  public static readonly HAS_NOT_COMMENT = 0;
  public static readonly HAS_COMMENT = 1;
  public static readonly NATURAL_PERSON = 1;
  public static readonly LEGAL_PERSON = 2;
  public static readonly SIGN_OPTION = 1;
  public static readonly REVIEW_OPTION = 2;
  public static readonly DEFAULT_ENTERPRISE_ID_VIEW = 1;
  public static readonly DEFAULT_JOB_ID = 1;
  public static readonly DEFAULT_PERSON_ID = 1;
  public static readonly DEFAULT_IOFE_ID_VIEW = 2;
  public static readonly DNI = 1;
  public static readonly CARNE_EXTRANJERIA = 2;
  public static readonly PASSAPORTE = 3;
  public static readonly SCHEMA = environment.apiBaseUrl.split(':', 1)[0];
  public static readonly ROLE_SUPERADMIN = 'ROLE_SUPERADMIN';
  public static readonly ROLE_PARTNER = 'ROLE_PARTNER';
  public static readonly ROLE_ADMIN = 'ROLE_ADMIN';
  public static readonly ROLE_LITE_ADMIN = 'ROLE_LITE_ADMIN';
  public static readonly ADMIN_IOFE = 'ADMIN_IOFE';
  public static readonly ROLE_ADMIN_NOTCER = 'ROLE_ADMIN_NOTCER';
  public static readonly ROLE_USER = 'ROLE_USER';
  public static readonly ROLE_ASSISTANT = 'ROLE_ASSISTANT';
  public static readonly ROLE_LITE_ASSISTANT = 'ROLE_LITE_ASSISTANT';
  public static readonly ROLE_SUPERVISOR = 'ROLE_SUPERVISOR';
  public static readonly REPLACEABLE = 1;
  public static readonly NOT_REPLACED = 0;
  public static readonly REPLACED = 1;
  public static readonly ADD_TSA = 1;
  public static readonly NOT_ADD_TSA = 0;
  public static readonly COMPLETED = 1;
  public static readonly INCOMPLETE = 0;
  public static readonly NOT_OBSERVED = 0;
  public static readonly OBSERVED = 1;
  public static readonly NOT_MANDATORY = 0;
  public static readonly MANDATORY = 1;
  public static readonly CANCEL = -1;
  public static readonly ADD = 1;
  public static readonly EDIT = 2;
  public static readonly DELETE = 3;
  public static readonly ADD_ON_DOCS = 3;
  public static readonly SEARCH_ON_DOCS = 4;
  public static readonly EDIT_ON_DOCS = 5;
  public static readonly HAS_MULTIPLE_ATTACHMENTS = 1;
  public static readonly NOT_SEND_ALERT = 0;
  public static readonly SEND_ALERT = 1;
  public static readonly ONLY_API_OPTION = '1';
  public static readonly NOT_SEND_NOTIFICATION = 0;
  public static readonly SEND_NOTIFICATION = 1;
  public static readonly SAVE_OPTION = 1;
  public static readonly PREVIEW_OPTION = 2;
  public static readonly FIRST_OPERATION = 1;
  public static readonly NOT_READY_TO_USE = 0;
  public static readonly READY_TO_USE = 1;
  public static readonly SIE_NOT_CONFIGURED = 0;
  public static readonly SIE_CONFIGURED = 1;
  public static readonly NOT_REQUIRED_SIE_CONFIG = 0;
  public static readonly REQUIRED_SIE_CONFIG = 1;
  public static readonly NOT_REMOVABLE = 0;
  public static readonly REMOVABLE = 1;
  public static readonly NOT_EDITABLE = 0;
  public static readonly EDITABLE = 1;
  public static readonly ROLE_AUTHORITY_MODE = 1;
  public static readonly USER_AUTHORITY_MODE = 2;
  public static readonly NOT_ONLY_SUPERADMIN = 0;
  public static readonly ONLY_SUPERADMIN = 1;
  public static readonly ZERO_INDEX = 0;
  public static readonly FIRST_INDEX = 1;
  public static readonly NOT_DELIVER = 0;
  public static readonly DELIVER = 1;
  public static readonly HAS_NOT_DELIVER_OPTION = 0;
  public static readonly HAS_DELIVER_OPTION = 1;
  public static readonly SIE_SIGN = 1;
  public static readonly SIE_NOTIFICATION = 2;
  public static readonly SIE_LAYOUT = 3;
  public static readonly STATICALLY = 0;
  public static readonly DYNAMICALLY = 1;
  public static readonly MINIMUM_PARTICIPANTS = 1;
  public static readonly MINIMUM_OPERATOR = 0;
  public static readonly OFF = 0;
  public static readonly ON = 1;
  public static readonly FIRST_OPERATOR = 1;
  public static readonly EMPTY_LIST = 0;
  public static readonly CORRECT_OPERATION = 1;
  public static readonly OLD_SIGNATURE = 1;
  public static readonly NEW_SIGNATURE = 0;
  public static readonly EXCLUDED = 1;
  public static readonly NOT_EXCLUDED = 0;
  public static readonly IOFE_COIN = '(IOF)';
  public static readonly IS_PARTNER = 1;
  public static readonly IS_NOT_PARTNER = 0;
  public static readonly HAS_NOT_CONFIG_BALANCE = 0;
  public static readonly HAS_CONFIG_BALANCE = 1;
  public static readonly HAS_CONFIG_DEMO_NOTCER = true;
  public static readonly ISNT_RETURNED_BALANCE = 0;
  public static readonly IS_RETURNED_BALANCE = 1;
  public static readonly OTHER_PAGESTAMP = 5;
  public static readonly SINCE_PAGESTAMP = 8;
  public static readonly UNTIL_PAGESTAMP = 9;
  public static readonly ALL_ENTERPRISE_ID = 0;
  public static readonly ALL_PARTNER_ID = 0;
  public static readonly ALL_WORKFLOW_ID = 0;
  public static readonly DEFAULT_IMAGE_PATH_235_150 = 'assets/image/placehold-it-235x150.png';
  public static readonly DEFAULT_IMAGE_PATH_80_40 = 'assets/image/placehold-it-80x40.png';
  public static readonly DEFAULT_IMAGE_PATH_RUBRIC = 'assets/image/rubric_ex.png';
  public static readonly DEFAULT_IMAGE_PATH_355_150 = 'assets/image/placehold-it-355x150.png';
  public static readonly DEFAULT_IMAGE = 'assets/image/image-default-330.jpg';
  public static readonly INITIAL_STORAGE = 500;
  public static readonly ROLE_SIMPLE = 'ROLE_SIMPLE_USER';
  public static readonly TABLE = 3;
  public static readonly EDIT_OPTION = 'edit';
  public static readonly CREATE_NEW_TEMPLATE = '1';
  public static readonly UPLOAD_TEMPLATE = '2';
  public static readonly RUC_IOFE = '20543237435';
  public static readonly TEXT = 2;
  public static readonly USER_ROLE_ID = '50';
  public static readonly HASNT_DOCUMENT_INTEGRITY = false;
  public static readonly AUTH_ACCOUNT = 'Autenticación de cuenta';
  public static readonly MILLISECONDS = 1000;
}
